export const SupportedLanguages = ['en', 'nl'];
